<template>
  <li
    v-focus
    tabindex="0"
    class="collapse-section__item title-medium-semibold"
    @click.prevent="active = !active"
    @keydown.enter="active = !active"
  >
    <slot name="title" :active="active"></slot>
    <transition name="rotate" mode="out-in">
      <i v-if="active" key="up" class="fa-solid fa-chevron-up"></i>
      <i v-else key="down" class="fa-solid fa-chevron-down"></i>
    </transition>
  </li>
  <ul v-show="active" class="collapse-section__content">
    <slot name="content" />
  </ul>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  initialActive: { type: Boolean, default: true },
});

const active = ref(props.initialActive); // OK to lose reactivity because we only use the prop to initialize

function open() {
  active.value = true;
}

function close() {
  active.value = false;
}

defineExpose({ open, close });
</script>

<style lang="scss" scoped>
.collapse-section__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4px;
  cursor: pointer;
}

.collapse-section__content {
  list-style: none;
  padding-left: 16px;
  margin: 8px 0;
  gap: 4px;
  display: flex;
  flex-direction: column;
}
</style>
